import { Accordion } from "@smartfaster-ui/components";
import { useTranslation } from "react-i18next";
import { useInteriorDesigner } from "../context/InteriorDesignerContext";
import { isCtaEnabled } from "../context/selectors";
import type { GenerationAction } from "../context/types";
import { useVocab } from "../hooks/useVocab";
import { ColorSwatchGrid } from "../selections/ColorSwatchGrid";
import { ExtraWishesInput } from "../selections/ExtraWishesInput";
import { Panel } from "./Panel";

export function WallColorPanel() {
  const { t } = useTranslation();
  const { state, dispatch } = useInteriorDesigner();
  const { vocab } = useVocab();
  const selections = state.panelSelections.wallColor;
  const ctaEnabled = isCtaEnabled({ state, panelId: "wallColor" });

  const handleCtaClick = () => {
    const actions: GenerationAction[] = [
      {
        type: "wall_color",
        ral_code: selections.ral_code ?? undefined,
        custom_text: selections.custom_text || undefined,
        extra_wensen: selections.extra_wensen || undefined,
        scope: "all",
      },
    ];
    dispatch({ type: "GENERATION_REQUESTED", actions });
  };

  return (
    <Panel
      ctaLabel={t("interiorDesigner.wallColor.cta")}
      ctaHintText={t("interiorDesigner.wallColor.ctaHint")}
      ctaEnabled={ctaEnabled}
      onCtaClick={handleCtaClick}
    >
      {vocab && (
        <Accordion
          multiple
          defaultValue={["popularColors", "customColor"]}
          variant="filled"
          color="surfaceSecondary"
        >
          <Accordion.Item
            value="popularColors"
            title={t("interiorDesigner.wallColor.popularColors")}
          >
            <ColorSwatchGrid
              options={vocab.ral_colors}
              value={selections.ral_code}
              onValueChange={({ value }) => {
                dispatch({
                  type: "SELECTION_CHANGED",
                  panel: "wallColor",
                  field: "ral_code",
                  value,
                });
                dispatch({
                  type: "SELECTION_CHANGED",
                  panel: "wallColor",
                  field: "custom_text",
                  value: "",
                });
              }}
            />
          </Accordion.Item>

          <Accordion.Item
            value="customColor"
            title={t("interiorDesigner.wallColor.customColor")}
          >
            <ExtraWishesInput
              value={selections.custom_text}
              onValueChange={({ value }) => {
                dispatch({
                  type: "SELECTION_CHANGED",
                  panel: "wallColor",
                  field: "custom_text",
                  value,
                });
                if (value.trim().length > 0) {
                  dispatch({
                    type: "SELECTION_CHANGED",
                    panel: "wallColor",
                    field: "ral_code",
                    value: null,
                  });
                }
              }}
              placeholder={t(
                "interiorDesigner.wallColor.customColorPlaceholder",
              )}
            />
          </Accordion.Item>
        </Accordion>
      )}
    </Panel>
  );
}
